import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { FormsModule } from '@angular/forms';
import { AbsoluteMediaUriService } from '../../../../services/absolute-media-uri.service';
import { ISearchesDTO } from '../../../../models/ISearchesDTO';
import { MySearchesService } from '../../../../services/bidder-community/my-searches/my-searches.service';
import { ToastMessageService } from '../../../../services/toast-message/toast-message.service';


@Component({
  selector: 'app-search-item',
  imports: [FaIconComponent, ToggleSwitchModule, FormsModule, CommonModule],
  templateUrl: './search-item.component.html',
  styleUrl: './search-item.component.scss'
})
export class SearchItemComponent {
  protected readonly absoluteMediaUriService = inject(AbsoluteMediaUriService);
  private readonly mySearchesService = inject(MySearchesService);
  private readonly messageService = inject(ToastMessageService);

  faTrashCan = faTrashCan;

  @Input() search:ISearchesDTO | null = null;

  @Output() confirm: EventEmitter<ISearchesDTO> = new EventEmitter();

  onCheckboxChange(search: ISearchesDTO){
    this.mySearchesService.putSearchEmailAlert(search).subscribe(({
      next: (result) => {
        this.messageService.success(`Email Alert updated successfully`);
      },
      error: (err) => {
        this.messageService.error(err || 'unknown error');
      }
    }))
  }

  confirmFunc(search: ISearchesDTO){
    this.confirm.emit(search);
  }

}
